module.exports = __webpack_public_path__ + "static/media/pierce.588df0b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/actions/pierce.svg
// module id = 98
// module chunks = 0